/* Playful "under the product" areas for the advent calendar pages (see assets/adv-play.css).
   Each area is a [data-adv="race|sandbox|tree|wave"] element with a <script type="application/json" data-adv-data> list of
   {img, name, line, alt}. Plain JS, no libraries; pointer events so it works with mouse and touch. */
(function () {
  'use strict';
  var LANG = String(document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var DICT = {
    ru: {
      'Pick {name}': 'Выбрать: {name}',
      'You picked the {name}. Press start!': 'Вы выбрали: {name}. Жмите кнопку старта!',
      'GO!': 'Вперёд!',
      'Watch them go!': 'Смотрите, как они мчатся!',
      'Results': 'Результаты',
      'Your {name} won! Race again?': 'Победа: {name}! Ещё заезд?',
      'Your {name} came {place}. Tap faster next time!': '{name}: место {n}. В следующий раз жмите быстрее!',
      'The {name} won!': 'Победил: {name}!',
      'Race again': 'Ещё раз',
      'Vroom! Watch out for the other cars.': 'Вжжжух! Осторожно, другие машинки!',
      '{n} crash': 'Столкновений: {n}',
      '{n} crashes': 'Столкновений: {n}',
      'CRASH! Two cars met.': 'БАМ! Две машинки встретились.',
      '{n} crashes! What a traffic jam.': 'Столкновений: {n}! Вот это пробка.',
      'BAM!': 'БАМ!',
      'CRASH!': 'КРАШ!',
      'BONK!': 'БОНК!',
      'WHAM!': 'ТРЕСЬ!',
      'Fresh start. Crash them all!': 'Начнём заново. Сталкивайте всех!',
      '{n} / {total} placed': 'На месте: {n} из {total}',
      'Now drag it into its slot below.': 'Теперь перетащите его в своё гнездо внизу.',
      'All found! Put them in their slots.': 'Все найдены! Разложите их по гнёздам.',
      'Which slot has its colour?': 'В каком гнезде такой же цвет?',
      'Collection complete!': 'Коллекция собрана!',
      'All {n} stones in their places, just like the box.': 'Все {n} камней на своих местах, как в коробке.',
      'Yes!': 'Верно!',
      '{name} goes in slot {n}.': '{name} — в гнездо {n}.',
      'Not that one. Look for the slot with {name}.': 'Не это. Ищите гнездо с камнем «{name}».',
      'Valid today only, until {time}': 'Действует только сегодня, до {time}',
      'Boom! You touched the dynamite.': 'Бум! Вы задели динамит.',
      'You hit a post.': 'Вы врезались в столб.',
      'You bit your own tail.': 'Вы укусили собственный хвост.',
      'A post appeared! Steer around it.': 'Появился столб! Обогните его.',
      'Goal reached! Your discount code is on screen.': 'Цель достигнута! Ваш промокод на экране.',
      'Copied!': 'Скопировано!',
      'Copy': 'Копировать',
      'Paused. Press an arrow to go on.': 'Пауза. Нажмите стрелку, чтобы продолжить.',
      'Goal': 'Цель',
      '5% off': 'Скидка 5%',
      '{text} on this toy!': '{text} на эту игрушку!',
      'Code': 'Код',
      'Valid this week, until {until}': 'Действует на этой неделе, до {until}',
      'Use it now': 'Применить сейчас',
      'Brick': 'Кирпич',
      'Stone': 'Камень',
      'Wood': 'Дерево',
      'Ice': 'Лёд',
      'Grass': 'Трава',
      'Lava': 'Лава',
      'Erase': 'Стереть',
      '{n} cubes': 'Кубиков: {n}',
      'Cubes only stick to the floor or to another cube.': 'Кубики крепятся только к полу или к другому кубику.',
      'Birthday crown': 'Праздничная корона',
      'Party Yeti wears a crown. Happy birthday!': 'Йети-тусовщик надел корону. С днём рождения!',
      'Plush cake': 'Плюшевый торт',
      'A plush cake with its own scent. Yum!': 'Плюшевый торт со своим ароматом. Ням!',
      'Scented rose': 'Ароматная роза',
      'Rose Yeti holds a rose that sticks on with a magnet.': 'Йети-роза держит розу, она крепится магнитом.',
      'Sleep mask': 'Маска для сна',
      'Shhh. Yeti is asleep. Sweet dreams.': 'Тсс. Йети спит. Сладких снов.',
      'Horse pal': 'Друг-лошадка',
      'A little horse pal for the bookshelf.': 'Маленький друг-лошадка для книжной полки.',
      'Yeti': 'Йети',
      'Hug him and the lavender comes out.': 'Обнимите его — и появится лаванда.',
      'Squish! Slowly, it puffs back.': 'Мяк! Медленно распрямляется.',
      'So soft.': 'Такой мягкий.',
      'Squeeze it again!': 'Сожмите ещё раз!',
      'Look at it wobble.': 'Смотрите, как он качается.',
      'Pleats and all.': 'Со всеми складочками.',
      'Ahh, satisfying.': 'Ааах, как приятно.',
      'Squishy dumpling {n}': 'Мягкий пельмень {n}',
      '{n} squishes': 'Сжатий: {n}',
      'Close game': 'Закрыть игру',
      'Close': 'Закрыть',
      'Play free': 'Играть бесплатно',
      'Free game': 'Бесплатная игра',
      'Play': 'Играть',
      'Big waves! Hold on, ducks!': 'Большие волны! Держитесь, уточки!'
    },
    de: {
      'Pick {name}': '{name} wählen',
      'You picked the {name}. Press start!': 'Sie haben {name} gewählt. Drücken Sie auf Start!',
      'GO!': 'LOS!',
      'Watch them go!': 'Sehen Sie, wie sie flitzen!',
      'Results': 'Ergebnisse',
      'Your {name} won! Race again?': '{name} hat gewonnen! Noch ein Rennen?',
      'Your {name} came {place}. Tap faster next time!': '{name} kam auf Platz {n}. Tippen Sie beim nächsten Mal schneller!',
      'The {name} won!': '{name} hat gewonnen!',
      'Race again': 'Nochmal fahren',
      'Vroom! Watch out for the other cars.': 'Brumm! Passen Sie auf die anderen Autos auf.',
      '{n} crash': 'Crashs: {n}',
      '{n} crashes': 'Crashs: {n}',
      'CRASH! Two cars met.': 'KRACH! Zwei Autos sind zusammengestoßen.',
      '{n} crashes! What a traffic jam.': '{n} Crashs! So ein Stau.',
      'BAM!': 'BAMM!',
      'CRASH!': 'KRACH!',
      'BONK!': 'BONK!',
      'WHAM!': 'WUMM!',
      'Fresh start. Crash them all!': 'Neuer Start. Lassen Sie sie alle krachen!',
      '{n} / {total} placed': '{n} / {total} platziert',
      'Now drag it into its slot below.': 'Ziehen Sie ihn jetzt unten in sein Fach.',
      'All found! Put them in their slots.': 'Alle gefunden! Setzen Sie sie in ihre Fächer.',
      'Which slot has its colour?': 'Welches Fach hat seine Farbe?',
      'Collection complete!': 'Sammlung komplett!',
      'All {n} stones in their places, just like the box.': 'Alle {n} Steine an ihrem Platz, genau wie in der Box.',
      'Yes!': 'Richtig!',
      '{name} goes in slot {n}.': '{name} gehört in Fach {n}.',
      'Not that one. Look for the slot with {name}.': 'Nicht das. Suchen Sie das Fach mit {name}.',
      'Valid today only, until {time}': 'Nur heute gültig, bis {time}',
      'Boom! You touched the dynamite.': 'Bumm! Sie haben das Dynamit berührt.',
      'You hit a post.': 'Sie sind gegen einen Pfosten geprallt.',
      'You bit your own tail.': 'Sie haben sich in den eigenen Schwanz gebissen.',
      'A post appeared! Steer around it.': 'Ein Pfosten ist aufgetaucht! Fahren Sie drum herum.',
      'Goal reached! Your discount code is on screen.': 'Ziel erreicht! Ihr Rabattcode steht auf dem Bildschirm.',
      'Copied!': 'Kopiert!',
      'Copy': 'Kopieren',
      'Paused. Press an arrow to go on.': 'Pause. Drücken Sie eine Pfeiltaste zum Weiterspielen.',
      'Goal': 'Ziel',
      '5% off': '5 % Rabatt',
      '{text} on this toy!': '{text} auf dieses Spielzeug!',
      'Code': 'Code',
      'Valid this week, until {until}': 'Gültig diese Woche, bis {until}',
      'Use it now': 'Jetzt einlösen',
      'Brick': 'Ziegel',
      'Stone': 'Stein',
      'Wood': 'Holz',
      'Ice': 'Eis',
      'Grass': 'Gras',
      'Lava': 'Lava',
      'Erase': 'Radieren',
      '{n} cubes': 'Würfel: {n}',
      'Cubes only stick to the floor or to another cube.': 'Würfel haften nur am Boden oder an einem anderen Würfel.',
      'Birthday crown': 'Geburtstagskrone',
      'Party Yeti wears a crown. Happy birthday!': 'Party-Yeti trägt eine Krone. Alles Gute zum Geburtstag!',
      'Plush cake': 'Plüschtorte',
      'A plush cake with its own scent. Yum!': 'Eine Plüschtorte mit eigenem Duft. Lecker!',
      'Scented rose': 'Duftende Rose',
      'Rose Yeti holds a rose that sticks on with a magnet.': 'Rosen-Yeti hält eine Rose, die per Magnet hält.',
      'Sleep mask': 'Schlafmaske',
      'Shhh. Yeti is asleep. Sweet dreams.': 'Pst. Der Yeti schläft. Süße Träume.',
      'Horse pal': 'Pferdefreund',
      'A little horse pal for the bookshelf.': 'Ein kleiner Pferdefreund fürs Bücherregal.',
      'Yeti': 'Yeti',
      'Hug him and the lavender comes out.': 'Umarmen Sie ihn und der Lavendelduft kommt heraus.',
      'Squish! Slowly, it puffs back.': 'Quetsch! Langsam plustert er sich wieder auf.',
      'So soft.': 'So weich.',
      'Squeeze it again!': 'Drücken Sie noch mal!',
      'Look at it wobble.': 'Sehen Sie, wie er wackelt.',
      'Pleats and all.': 'Mit allen Falten.',
      'Ahh, satisfying.': 'Ahh, wie schön.',
      'Squishy dumpling {n}': 'Weiche Teigtasche {n}',
      '{n} squishes': 'Gequetscht: {n}',
      'Close game': 'Spiel schließen',
      'Close': 'Schließen',
      'Play free': 'Gratis spielen',
      'Free game': 'Gratis-Spiel',
      'Play': 'Spielen',
      'Big waves! Hold on, ducks!': 'Große Wellen! Haltet euch fest, Entchen!'
    },
    es: {
      'Pick {name}': 'Elegir {name}',
      'You picked the {name}. Press start!': 'Eligió: {name}. ¡Pulse el botón de inicio!',
      'GO!': '¡YA!',
      'Watch them go!': '¡Mire cómo van!',
      'Results': 'Resultados',
      'Your {name} won! Race again?': '¡{name} ganó! ¿Otra carrera?',
      'Your {name} came {place}. Tap faster next time!': '{name} quedó en el puesto {n}. ¡La próxima vez toque más rápido!',
      'The {name} won!': '¡Ganó {name}!',
      'Race again': 'Otra carrera',
      'Vroom! Watch out for the other cars.': '¡Brum! Cuidado con los otros coches.',
      '{n} crash': 'Choques: {n}',
      '{n} crashes': 'Choques: {n}',
      'CRASH! Two cars met.': '¡CRASH! Dos coches chocaron.',
      '{n} crashes! What a traffic jam.': '¡{n} choques! Qué atasco.',
      'BAM!': '¡PUM!',
      'CRASH!': '¡CRASH!',
      'BONK!': '¡TOC!',
      'WHAM!': '¡ZAS!',
      'Fresh start. Crash them all!': 'Empezamos de nuevo. ¡Choque con todos!',
      '{n} / {total} placed': '{n} / {total} colocadas',
      'Now drag it into its slot below.': 'Ahora arrástrela a su hueco de abajo.',
      'All found! Put them in their slots.': '¡Todas encontradas! Colóquelas en sus huecos.',
      'Which slot has its colour?': '¿Qué hueco tiene su color?',
      'Collection complete!': '¡Colección completa!',
      'All {n} stones in their places, just like the box.': 'Las {n} piedras en su sitio, igual que en la caja.',
      'Yes!': '¡Sí!',
      '{name} goes in slot {n}.': '{name} va en el hueco {n}.',
      'Not that one. Look for the slot with {name}.': 'Ese no. Busque el hueco de {name}.',
      'Valid today only, until {time}': 'Válido solo hoy, hasta las {time}',
      'Boom! You touched the dynamite.': '¡Bum! Tocó la dinamita.',
      'You hit a post.': 'Chocó con un poste.',
      'You bit your own tail.': 'Se mordió la cola.',
      'A post appeared! Steer around it.': '¡Apareció un poste! Ródeelo.',
      'Goal reached! Your discount code is on screen.': '¡Meta alcanzada! Su código de descuento está en pantalla.',
      'Copied!': '¡Copiado!',
      'Copy': 'Copiar',
      'Paused. Press an arrow to go on.': 'Pausa. Pulse una flecha para seguir.',
      'Goal': 'Meta',
      '5% off': '5 % de descuento',
      '{text} on this toy!': '¡{text} en este juguete!',
      'Code': 'Código',
      'Valid this week, until {until}': 'Válido esta semana, hasta {until}',
      'Use it now': 'Usar ahora',
      'Brick': 'Ladrillo',
      'Stone': 'Piedra',
      'Wood': 'Madera',
      'Ice': 'Hielo',
      'Grass': 'Hierba',
      'Lava': 'Lava',
      'Erase': 'Borrar',
      '{n} cubes': 'Cubos: {n}',
      'Cubes only stick to the floor or to another cube.': 'Los cubos solo se pegan al suelo o a otro cubo.',
      'Birthday crown': 'Corona de cumpleaños',
      'Party Yeti wears a crown. Happy birthday!': 'El Yeti de fiesta lleva una corona. ¡Feliz cumpleaños!',
      'Plush cake': 'Tarta de peluche',
      'A plush cake with its own scent. Yum!': 'Una tarta de peluche con su propio aroma. ¡Qué rica!',
      'Scented rose': 'Rosa perfumada',
      'Rose Yeti holds a rose that sticks on with a magnet.': 'El Yeti rosa sostiene una rosa que se pega con un imán.',
      'Sleep mask': 'Antifaz para dormir',
      'Shhh. Yeti is asleep. Sweet dreams.': 'Shhh. El Yeti duerme. Dulces sueños.',
      'Horse pal': 'Amigo caballito',
      'A little horse pal for the bookshelf.': 'Un caballito amigo para la estantería.',
      'Yeti': 'Yeti',
      'Hug him and the lavender comes out.': 'Abrácelo y sale la lavanda.',
      'Squish! Slowly, it puffs back.': '¡Squish! Poco a poco recupera su forma.',
      'So soft.': 'Qué suave.',
      'Squeeze it again!': '¡Apriételo otra vez!',
      'Look at it wobble.': 'Mire cómo se bambolea.',
      'Pleats and all.': 'Con todos sus pliegues.',
      'Ahh, satisfying.': 'Ahh, qué satisfactorio.',
      'Squishy dumpling {n}': 'Empanadilla blandita {n}',
      '{n} squishes': 'Apretones: {n}',
      'Close game': 'Cerrar el juego',
      'Close': 'Cerrar',
      'Play free': 'Jugar gratis',
      'Free game': 'Juego gratis',
      'Play': 'Jugar',
      'Big waves! Hold on, ducks!': '¡Olas gigantes! ¡Agárrense, patitos!'
    },
    fr: {
      'Pick {name}': 'Choisir {name}',
      'You picked the {name}. Press start!': 'Vous avez choisi : {name}. Appuyez sur le bouton de départ !',
      'GO!': 'GO !',
      'Watch them go!': 'Regardez-les filer !',
      'Results': 'Résultats',
      'Your {name} won! Race again?': '{name} a gagné ! On refait une course ?',
      'Your {name} came {place}. Tap faster next time!': '{name} est arrivé à la place {n}. Tapez plus vite la prochaine fois !',
      'The {name} won!': '{name} a gagné !',
      'Race again': 'Courir encore',
      'Vroom! Watch out for the other cars.': 'Vroum ! Attention aux autres voitures.',
      '{n} crash': 'Collisions : {n}',
      '{n} crashes': 'Collisions : {n}',
      'CRASH! Two cars met.': 'CRASH ! Deux voitures se sont percutées.',
      '{n} crashes! What a traffic jam.': '{n} collisions ! Quel embouteillage.',
      'BAM!': 'BAM !',
      'CRASH!': 'CRASH !',
      'BONK!': 'BONK !',
      'WHAM!': 'WHAM !',
      'Fresh start. Crash them all!': 'On repart à zéro. Faites-les tous se percuter !',
      '{n} / {total} placed': '{n} / {total} placées',
      'Now drag it into its slot below.': 'Faites-la glisser dans son emplacement en bas.',
      'All found! Put them in their slots.': 'Toutes trouvées ! Placez-les dans leurs emplacements.',
      'Which slot has its colour?': 'Quel emplacement a sa couleur ?',
      'Collection complete!': 'Collection complète !',
      'All {n} stones in their places, just like the box.': 'Les {n} pierres sont à leur place, comme dans la boîte.',
      'Yes!': 'Oui !',
      '{name} goes in slot {n}.': '{name} va dans l’emplacement {n}.',
      'Not that one. Look for the slot with {name}.': 'Pas celui-là. Cherchez l’emplacement de {name}.',
      'Valid today only, until {time}': 'Valable aujourd’hui seulement, jusqu’à {time}',
      'Boom! You touched the dynamite.': 'Boum ! Vous avez touché la dynamite.',
      'You hit a post.': 'Vous avez heurté un poteau.',
      'You bit your own tail.': 'Vous vous êtes mordu la queue.',
      'A post appeared! Steer around it.': 'Un poteau est apparu ! Contournez-le.',
      'Goal reached! Your discount code is on screen.': 'Objectif atteint ! Votre code de réduction est à l’écran.',
      'Copied!': 'Copié !',
      'Copy': 'Copier',
      'Paused. Press an arrow to go on.': 'Pause. Appuyez sur une flèche pour continuer.',
      'Goal': 'Objectif',
      '5% off': '5 % de réduction',
      '{text} on this toy!': '{text} sur ce jouet !',
      'Code': 'Code',
      'Valid this week, until {until}': 'Valable cette semaine, jusqu’à {until}',
      'Use it now': 'L’utiliser maintenant',
      'Brick': 'Brique',
      'Stone': 'Pierre',
      'Wood': 'Bois',
      'Ice': 'Glace',
      'Grass': 'Herbe',
      'Lava': 'Lave',
      'Erase': 'Effacer',
      '{n} cubes': 'Cubes : {n}',
      'Cubes only stick to the floor or to another cube.': 'Les cubes ne tiennent qu’au sol ou à un autre cube.',
      'Birthday crown': 'Couronne d’anniversaire',
      'Party Yeti wears a crown. Happy birthday!': 'Le Yéti fêtard porte une couronne. Joyeux anniversaire !',
      'Plush cake': 'Gâteau en peluche',
      'A plush cake with its own scent. Yum!': 'Un gâteau en peluche avec son propre parfum. Miam !',
      'Scented rose': 'Rose parfumée',
      'Rose Yeti holds a rose that sticks on with a magnet.': 'Le Yéti rose tient une rose fixée par un aimant.',
      'Sleep mask': 'Masque de sommeil',
      'Shhh. Yeti is asleep. Sweet dreams.': 'Chut. Le Yéti dort. Faites de beaux rêves.',
      'Horse pal': 'Ami cheval',
      'A little horse pal for the bookshelf.': 'Un petit ami cheval pour l’étagère.',
      'Yeti': 'Yéti',
      'Hug him and the lavender comes out.': 'Faites-lui un câlin et la lavande se libère.',
      'Squish! Slowly, it puffs back.': 'Scouich ! Lentement, il reprend sa forme.',
      'So soft.': 'Tellement doux.',
      'Squeeze it again!': 'Pressez-le encore !',
      'Look at it wobble.': 'Regardez comme il tremble.',
      'Pleats and all.': 'Avec tous ses plis.',
      'Ahh, satisfying.': 'Ahh, tellement satisfaisant.',
      'Squishy dumpling {n}': 'Dumpling tout doux {n}',
      '{n} squishes': 'Pressions : {n}',
      'Close game': 'Fermer le jeu',
      'Close': 'Fermer',
      'Play free': 'Jouer gratuitement',
      'Free game': 'Jeu gratuit',
      'Play': 'Jouer',
      'Big waves! Hold on, ducks!': 'De grosses vagues ! Accrochez-vous, les canards !'
    },
    ar: {
      'Pick {name}': 'اختر {name}',
      'You picked the {name}. Press start!': 'اخترت: {name}. اضغط زر البدء!',
      'GO!': 'انطلق!',
      'Watch them go!': 'شاهدها وهي تنطلق!',
      'Results': 'النتائج',
      'Your {name} won! Race again?': 'فاز {name}! سباق آخر؟',
      'Your {name} came {place}. Tap faster next time!': '{name} جاء في المركز {n}. اضغط أسرع في المرة القادمة!',
      'The {name} won!': 'فاز {name}!',
      'Race again': 'سباق جديد',
      'Vroom! Watch out for the other cars.': 'برررم! انتبه للسيارات الأخرى.',
      '{n} crash': 'التصادمات: {n}',
      '{n} crashes': 'التصادمات: {n}',
      'CRASH! Two cars met.': 'تصادم! التقت سيارتان.',
      '{n} crashes! What a traffic jam.': '{n} تصادمات! يا له من ازدحام.',
      'BAM!': 'بام!',
      'CRASH!': 'تصادم!',
      'BONK!': 'طَق!',
      'WHAM!': 'وام!',
      'Fresh start. Crash them all!': 'بداية جديدة. صادم السيارات كلها!',
      '{n} / {total} placed': 'تم وضع {n} / {total}',
      'Now drag it into its slot below.': 'الآن اسحبه إلى خانته في الأسفل.',
      'All found! Put them in their slots.': 'وجدتها كلها! ضعها في خاناتها.',
      'Which slot has its colour?': 'أي خانة بلونه؟',
      'Collection complete!': 'اكتملت المجموعة!',
      'All {n} stones in their places, just like the box.': 'كل الأحجار الـ {n} في أماكنها، تمامًا كما في العلبة.',
      'Yes!': 'صحيح!',
      '{name} goes in slot {n}.': '{name} مكانه الخانة {n}.',
      'Not that one. Look for the slot with {name}.': 'ليست هذه. ابحث عن خانة {name}.',
      'Valid today only, until {time}': 'صالح اليوم فقط، حتى {time}',
      'Boom! You touched the dynamite.': 'بوم! لمست الديناميت.',
      'You hit a post.': 'اصطدمت بعمود.',
      'You bit your own tail.': 'عضضت ذيلك.',
      'A post appeared! Steer around it.': 'ظهر عمود! دُر حوله.',
      'Goal reached! Your discount code is on screen.': 'تحقق الهدف! رمز الخصم ظاهر على الشاشة.',
      'Copied!': 'تم النسخ!',
      'Copy': 'نسخ',
      'Paused. Press an arrow to go on.': 'إيقاف مؤقت. اضغط على سهم للمتابعة.',
      'Goal': 'الهدف',
      '5% off': 'خصم 5%',
      '{text} on this toy!': '{text} على هذه اللعبة!',
      'Code': 'الرمز',
      'Valid this week, until {until}': 'صالح هذا الأسبوع، حتى {until}',
      'Use it now': 'استخدمه الآن',
      'Brick': 'طوب',
      'Stone': 'حجر',
      'Wood': 'خشب',
      'Ice': 'جليد',
      'Grass': 'عشب',
      'Lava': 'حمم',
      'Erase': 'محو',
      '{n} cubes': 'المكعبات: {n}',
      'Cubes only stick to the floor or to another cube.': 'تلتصق المكعبات بالأرض أو بمكعب آخر فقط.',
      'Birthday crown': 'تاج عيد الميلاد',
      'Party Yeti wears a crown. Happy birthday!': 'اليتي الاحتفالي يضع تاجًا. عيد ميلاد سعيد!',
      'Plush cake': 'كعكة قطيفة',
      'A plush cake with its own scent. Yum!': 'كعكة قطيفة لها عطرها الخاص. لذيذ!',
      'Scented rose': 'وردة عطرة',
      'Rose Yeti holds a rose that sticks on with a magnet.': 'اليتي الوردي يحمل وردة تثبت بمغناطيس.',
      'Sleep mask': 'قناع النوم',
      'Shhh. Yeti is asleep. Sweet dreams.': 'ششش. اليتي نائم. أحلامًا سعيدة.',
      'Horse pal': 'صديق الحصان',
      'A little horse pal for the bookshelf.': 'صديق حصان صغير لرف الكتب.',
      'Yeti': 'اليتي',
      'Hug him and the lavender comes out.': 'اعتنقه وسيخرج عطر اللافندر.',
      'Squish! Slowly, it puffs back.': 'اضغط! ببطء يعود لشكله.',
      'So soft.': 'ناعم جدًا.',
      'Squeeze it again!': 'اعصره مرة أخرى!',
      'Look at it wobble.': 'انظر كيف يهتز.',
      'Pleats and all.': 'مع كل طياته.',
      'Ahh, satisfying.': 'آه، شعور رائع.',
      'Squishy dumpling {n}': 'دمبلنغ طري {n}',
      '{n} squishes': 'الضغطات: {n}',
      'Close game': 'إغلاق اللعبة',
      'Close': 'إغلاق',
      'Play free': 'العب مجانًا',
      'Free game': 'لعبة مجانية',
      'Play': 'العب',
      'Big waves! Hold on, ducks!': 'أمواج كبيرة! تمسكوا يا بطات!'
    }
  };
  function T(s, v) { var o = (DICT[LANG] || {})[s] || s; if (v) for (var k in v) o = o.split('{' + k + '}').join(v[k]); return o; }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function rootPath(el) { var r = (el && el.getAttribute('data-root')) || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; return r.replace(/\/$/, ''); }   /* '' on the default language, '/ru' etc. otherwise */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function shuffle(a) { for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
  function img(it) { return '<img src="' + esc(it.img) + '" alt="' + esc(it.alt || it.name) + '" loading="lazy" width="240" height="240" draggable="false">'; }
  function ordinal(n) { return ['1st', '2nd', '3rd'][n - 1] || n + 'th'; }

  /* ---------------- Race ---------------- */
  function initRace(root, items) {
    var lanesEl = root.querySelector('[data-lanes]'), msg = root.querySelector('[data-msg]'), board = root.querySelector('[data-board]'),
      go = root.querySelector('[data-go]'), startBtn = root.querySelector('[data-start]'), newBtn = root.querySelector('[data-new]');
    var racers = [], pick = -1, state = 'idle', raf = 0, last = 0, finished = [];

    function setup() {
      cancelAnimationFrame(raf); state = 'idle'; pick = -1; finished = [];
      board.hidden = true; board.innerHTML = '';
      var pool = shuffle(items.slice()).slice(0, 6);
      lanesEl.innerHTML = '';
      racers = pool.map(function (it, i) {
        var lane = document.createElement('button');
        lane.type = 'button'; lane.className = 'race__lane'; lane.setAttribute('aria-label', T('Pick {name}', { name: it.name }));
        lane.innerHTML = '<span class="race__num">' + (i + 1) + '</span><span class="race__road"><span class="race__car">' + img(it) + '</span><span class="race__name">' + esc(it.name) + '</span></span><span class="race__flag"></span>';
        lanesEl.appendChild(lane);
        var r = { it: it, lane: lane, car: lane.querySelector('.race__car'), road: lane.querySelector('.race__road'), p: 0, v: 0.13 + Math.random() * 0.03, done: false };
        lane.addEventListener('pointerdown', function () { onLane(i); });
        return r;
      });
      draw();
      startBtn.disabled = false; startBtn.textContent = startBtn.dataset.label;
      msg.textContent = msg.dataset.pick;
    }
    function draw() {
      racers.forEach(function (r) {
        var w = r.road.clientWidth - r.car.offsetWidth - 6;
        r.car.style.transform = 'translateX(' + Math.max(0, r.p * w) + 'px)';
      });
    }
    function onLane(i) {
      if (state === 'idle') {
        pick = i;
        racers.forEach(function (r, k) { r.lane.classList.toggle('is-picked', k === i); });
        msg.textContent = T('You picked the {name}. Press start!', { name: racers[i].it.name });
      } else if (state === 'run' && i === pick && !racers[i].done) {
        racers[i].p = Math.min(1, racers[i].p + 0.028);
      }
    }
    function start() {
      if (state !== 'idle') return;
      state = 'count'; startBtn.disabled = true;
      var n = 3;
      (function tick() {
        go.textContent = n > 0 ? n : T('GO!'); go.classList.remove('is-on'); void go.offsetWidth; go.classList.add('is-on');
        if (n-- > 0) { setTimeout(tick, 700); } else {
          state = 'run'; last = performance.now(); msg.textContent = pick > -1 ? msg.dataset.tap : T('Watch them go!');
          raf = requestAnimationFrame(frame);
        }
      })();
    }
    function frame(t) {
      var dt = Math.min(0.05, (t - last) / 1000); last = t;
      racers.forEach(function (r) {
        if (r.done) return;
        r.v += (Math.random() - 0.5) * 0.05 * dt * 60 * 0.1; r.v = Math.max(0.085, Math.min(0.2, r.v));
        r.p += r.v * dt;
        if (r.p >= 1) { r.p = 1; r.done = true; finished.push(r); r.lane.classList.toggle('is-win', finished.length === 1); }
      });
      draw();
      if (finished.length < racers.length) { raf = requestAnimationFrame(frame); } else { end(); }
    }
    function end() {
      state = 'done';
      board.hidden = false;
      board.innerHTML = '<b>' + T('Results') + '</b><ol>' + finished.map(function (r) { return '<li>' + esc(r.it.name) + '</li>'; }).join('') + '</ol>';
      if (pick > -1) {
        var place = finished.indexOf(racers[pick]) + 1;
        msg.textContent = place === 1 ? T('Your {name} won! Race again?', { name: racers[pick].it.name }) : T('Your {name} came {place}. Tap faster next time!', { name: racers[pick].it.name, place: ordinal(place), n: place });
      } else { msg.textContent = T('The {name} won!', { name: finished[0].it.name }); }
      startBtn.textContent = T('Race again'); startBtn.disabled = false;
      startBtn.onclick = function () { setup(); startBtn.onclick = null; };
    }
    startBtn.dataset.label = startBtn.textContent;
    startBtn.addEventListener('click', function () { if (!startBtn.onclick) start(); });
    newBtn.addEventListener('click', setup);
    window.addEventListener('resize', draw);
    setup();
  }

  /* ---------------- Sandbox ---------------- */
  function initSandbox(root, items) {
    var box = root.querySelector('[data-box]'), cv = root.querySelector('canvas'), ctx = cv.getContext('2d'), clear = root.querySelector('[data-clear]'),
      pull = root.querySelector('.sb__pull line'), label = root.querySelector('.sb__label'), msg = root.querySelector('[data-msg]'), countEl = root.querySelector('[data-count]');
    var cars = [], dpr = Math.min(2, window.devicePixelRatio || 1), W = 0, H = 0, S = 78, R = 30, z = 10, drag = null, raf = 0, last = 0, crashes = 0, hits = 0;

    function size() {
      W = box.clientWidth; H = box.clientHeight; S = W < 520 ? 58 : 80; R = S * 0.36; box.style.setProperty('--car', S + 'px');
      cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function put(c) { c.el.style.transform = 'translate(' + c.x + 'px,' + c.y + 'px)'; c.img.style.transform = 'rotate(' + (c.tilt || 0).toFixed(1) + 'deg)'; }
    function build() {
      size();
      var cols = W < 520 ? 4 : 6, rows = Math.ceil(items.length / cols), cw = W / cols, ch = H / rows;
      cars = items.map(function (it, i) {
        var el = document.createElement('div'); el.className = 'sb__car'; el.setAttribute('role', 'img'); el.setAttribute('aria-label', it.name);
        el.innerHTML = '<span class="sb__shadow"></span><span class="sb__img">' + img(it) + '</span>';
        box.appendChild(el);
        var c = { it: it, el: el, img: el.querySelector('.sb__img'), x: (i % cols) * cw + cw / 2 - S / 2 + (Math.random() - 0.5) * cw * 0.25, y: Math.floor(i / cols) * ch + ch / 2 - S / 2 + (Math.random() - 0.5) * ch * 0.25, vx: 0, vy: 0, tilt: (Math.random() - 0.5) * 8, moving: false, drag: false };
        c.x = Math.max(4, Math.min(W - S - 4, c.x)); c.y = Math.max(4, Math.min(H - S - 4, c.y));
        put(c);
        el.addEventListener('pointerdown', function (e) { down(e, c); });
        return c;
      });
      if (!reduce) cars[0].el.classList.add('is-hint');
    }
    function down(e, c) {
      e.preventDefault(); cars.forEach(function (k) { k.el.classList.remove('is-hint'); });
      c.moving = false; c.vx = c.vy = 0; c.drag = true;
      try { c.el.setPointerCapture(e.pointerId); } catch (err) { /* synthetic or already released pointer */ }
      c.el.classList.add('is-drag'); c.el.style.zIndex = ++z;
      var r = box.getBoundingClientRect();
      drag = { c: c, sx: c.x, sy: c.y };
      label.textContent = c.it.name; label.hidden = false; moveLabel(c);
      c.el.onpointermove = function (ev) {
        var px = ev.clientX - r.left - S / 2, py = ev.clientY - r.top - S / 2;
        var dx = px - drag.sx, dy = py - drag.sy, d = Math.hypot(dx, dy), max = Math.min(150, Math.min(W, H) * 0.32);
        if (d > max) { dx *= max / d; dy *= max / d; }
        c.x = drag.sx + dx; c.y = drag.sy + dy; c.tilt = dx > 0 ? -5 : 5; put(c); moveLabel(c);
        pull.setAttribute('x1', drag.sx + S / 2); pull.setAttribute('y1', drag.sy + S / 2); pull.setAttribute('x2', c.x + S / 2); pull.setAttribute('y2', c.y + S / 2);
      };
      c.el.onpointerup = c.el.onpointercancel = function () { up(c); };
    }
    function moveLabel(c) { label.style.left = (c.x + S / 2) + 'px'; label.style.top = c.y + 'px'; }
    function up(c) {
      c.el.onpointermove = c.el.onpointerup = c.el.onpointercancel = null;
      c.el.classList.remove('is-drag'); label.hidden = true; c.drag = false;
      pull.setAttribute('x1', 0); pull.setAttribute('y1', 0); pull.setAttribute('x2', 0); pull.setAttribute('y2', 0);
      var vx = (drag.sx - c.x) * 0.22, vy = (drag.sy - c.y) * 0.22, sp = Math.hypot(vx, vy);
      if (sp > 32) { vx *= 32 / sp; vy *= 32 / sp; }
      c.vx = vx; c.vy = vy; c.moving = sp > 1.2; drag = null;
      if (c.moving) { msg.textContent = T('Vroom! Watch out for the other cars.'); wake(); } else { c.tilt = 0; put(c); }
    }
    function wake() { if (!raf) { last = performance.now(); raf = requestAnimationFrame(frame); } }
    function boom(x, y, power) {
      var b = document.createElement('span'); b.className = 'sb__boom'; b.style.left = x + 'px'; b.style.top = y + 'px';
      b.style.setProperty('--s', Math.min(1.6, 0.7 + power / 14).toFixed(2)); b.textContent = T(['BAM!', 'CRASH!', 'BONK!', 'WHAM!'][Math.floor(Math.random() * 4)]);
      box.appendChild(b); setTimeout(function () { b.remove(); }, 650);
    }
    function collide(a, b) {
      var ax = a.x + S / 2, ay = a.y + S / 2, bx = b.x + S / 2, by = b.y + S / 2, dx = bx - ax, dy = by - ay, d = Math.hypot(dx, dy), min = R * 2;
      if (d >= min) return;
      if (d < 0.01) { dx = 1; dy = 0; d = 1; }
      var nx = dx / d, ny = dy / d, overlap = min - d;
      // push them apart (a dragged car stays where the finger holds it)
      var wa = a.drag ? 0 : 1, wb = b.drag ? 0 : 1, wt = wa + wb; if (!wt) return;
      a.x -= nx * overlap * (wa / wt); a.y -= ny * overlap * (wa / wt); b.x += nx * overlap * (wb / wt); b.y += ny * overlap * (wb / wt);
      var rv = (b.vx - a.vx) * nx + (b.vy - a.vy) * ny;       // closing speed along the normal (negative = approaching)
      if (rv < 0) {
        var j = -(1 + 0.82) * rv / wt;
        a.vx -= j * wa * nx; a.vy -= j * wa * ny; b.vx += j * wb * nx; b.vy += j * wb * ny;
        var power = -rv;
        if (power > 2.2) {
          hits++; crashes++; if (countEl) countEl.textContent = T(crashes === 1 ? '{n} crash' : '{n} crashes', { n: crashes });
          boom((ax + bx) / 2, (ay + by) / 2, power);
          a.tilt += (Math.random() - 0.5) * 14; b.tilt += (Math.random() - 0.5) * 14;
          if (crashes === 1 || crashes % 5 === 0) msg.textContent = crashes < 5 ? 'CRASH! Two cars met.' : crashes + ' crashes! What a traffic jam.';
        }
        a.moving = a.moving || Math.hypot(a.vx, a.vy) > 0.3; b.moving = b.moving || Math.hypot(b.vx, b.vy) > 0.3;
      }
    }
    function frame(t) {
      var k = Math.min(3, (t - last) / 16.67); last = t; var any = false, i, j, c;
      for (i = 0; i < cars.length; i++) {
        c = cars[i]; if (!c.moving || c.drag) continue;
        var ox = c.x + S / 2, oy = c.y + S / 2;
        c.x += c.vx * k; c.y += c.vy * k;
        var m = 3;
        if (c.x < m) { c.x = m; c.vx *= -0.6; } if (c.x > W - S - m) { c.x = W - S - m; c.vx *= -0.6; }
        if (c.y < m) { c.y = m; c.vy *= -0.6; } if (c.y > H - S - m) { c.y = H - S - m; c.vy *= -0.6; }
        var f = Math.pow(0.972, k); c.vx *= f; c.vy *= f; c.tilt *= Math.pow(0.9, k);
        if (Math.hypot(c.vx, c.vy) > 0.3) {
          ctx.strokeStyle = 'rgba(255,255,255,.10)'; ctx.lineWidth = 5; ctx.lineCap = 'round';
          ctx.beginPath(); ctx.moveTo(ox, oy + S * 0.18); ctx.lineTo(c.x + S / 2, c.y + S / 2 + S * 0.18); ctx.stroke();
        } else { c.moving = false; c.vx = c.vy = 0; }
      }
      for (i = 0; i < cars.length; i++) for (j = i + 1; j < cars.length; j++) collide(cars[i], cars[j]);   // 24 cars = 276 pairs, cheap
      for (i = 0; i < cars.length; i++) {
        c = cars[i]; if (c.moving && !c.drag) any = true;
        c.x = Math.max(3, Math.min(W - S - 3, c.x)); c.y = Math.max(3, Math.min(H - S - 3, c.y));
        if (c.moving || Math.abs(c.tilt) > 0.2) put(c);
      }
      raf = any ? requestAnimationFrame(frame) : 0;
    }
    clear.addEventListener('click', function () { ctx.clearRect(0, 0, W, H); crashes = 0; if (countEl) countEl.textContent = T('{n} crashes', { n: 0 }); msg.textContent = T('Fresh start. Crash them all!'); });
    function spread() {
      var cols = W < 520 ? 4 : 6, rows = Math.ceil(cars.length / cols), cw = W / cols, ch = H / rows;
      cars.forEach(function (c, i) {
        c.x = Math.max(4, Math.min(W - S - 4, (i % cols) * cw + cw / 2 - S / 2 + (Math.random() - 0.5) * cw * 0.2));
        c.y = Math.max(4, Math.min(H - S - 4, Math.floor(i / cols) * ch + ch / 2 - S / 2 + (Math.random() - 0.5) * ch * 0.2));
        c.vx = c.vy = 0; c.moving = false; c.tilt = (Math.random() - 0.5) * 8; put(c);
      });
    }
    var rt; function refit() { clearTimeout(rt); rt = setTimeout(function () { size(); if (!crashes && !drag) spread(); else cars.forEach(function (c) { c.x = Math.min(c.x, W - S); c.y = Math.min(c.y, H - S); put(c); }); }, 150); }
    window.addEventListener('resize', refit); root.addEventListener('advp:resize', refit);
    build();
  }

  /* ---------------- Stone tree ---------------- */
  function initTree(root, items) {
    var stage = root.querySelector('[data-stage]'), info = root.querySelector('[data-msg]');
    var rows = [2, 3, 4, 5, 5, 5], ys = [24, 35, 47, 59, 71, 83], half = [13, 19, 25, 31, 37, 43], idx = 0, timer;
    rows.forEach(function (n, r) {
      var s = Math.min(2 * half[r] / n, 17);
      for (var i = 0; i < n && idx < items.length; i++, idx++) {
        var it = items[idx], g = document.createElement('button');
        g.type = 'button'; g.className = 'gt__gem'; g.setAttribute('aria-label', it.name + ': ' + it.line);
        g.style.left = (50 + (i - (n - 1) / 2) * s) + '%'; g.style.top = ys[r] + '%';
        g.style.setProperty('--dur', (3.2 + Math.random() * 2.4).toFixed(2) + 's'); g.style.setProperty('--dl', (-Math.random() * 4).toFixed(2) + 's'); g.style.setProperty('--a', (2 + Math.random() * 3).toFixed(1) + 'deg');
        g.innerHTML = '<span class="gt__img">' + img(it) + '</span><span class="gt__tip">' + esc(it.name) + '</span>';
        g.addEventListener('pointerdown', (function (it, g) { return function () {
          g.classList.remove('is-pop'); void g.offsetWidth; g.classList.add('is-pop');
          info.innerHTML = '<b>' + esc(it.name) + '.</b> ' + esc(it.line);
          clearTimeout(g._t); g._t = setTimeout(function () { g.classList.remove('is-pop'); }, 2000);
        }; })(it, g));
        stage.appendChild(g);
      }
    });
  }

  /* ---------------- Treasure dig (drawn stones, no photos) ---------------- */
  function hexToHsl(h) {
    h = h.replace('#', ''); var r = parseInt(h.slice(0, 2), 16) / 255, g = parseInt(h.slice(2, 4), 16) / 255, b = parseInt(h.slice(4, 6), 16) / 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2, d = mx - mn, hh = 0, ss = 0;
    if (d) { ss = l > 0.5 ? d / (2 - mx - mn) : d / (mx + mn); hh = mx === r ? (g - b) / d + (g < b ? 6 : 0) : mx === g ? (b - r) / d + 2 : (r - g) / d + 4; hh *= 60; }
    return [hh, ss * 100, l * 100];
  }
  function hsl(h, s, l) { return 'hsl(' + Math.round(h) + ',' + Math.round(Math.max(0, Math.min(100, s))) + '%,' + Math.round(Math.max(4, Math.min(96, l))) + '%)'; }
  var GEM_SHAPES = [
    function (c) { /* tumbled pebble */ return '<path d="M12 40C8 26 18 10 34 9c16-1 27 10 25 26-2 15-16 21-29 19C21 53 14 49 12 40z" fill="url(#g)"/><ellipse cx="26" cy="22" rx="11" ry="6" fill="#fff" opacity=".35" transform="rotate(-25 26 22)"/><ellipse cx="44" cy="44" rx="9" ry="4" fill="#000" opacity=".12"/>'; },
    function (c) { /* faceted gem */ return '<path d="M32 6l20 12 10 14-30 28L2 32 12 18z" fill="url(#g)"/><path d="M12 18h40M2 32h60M32 6l-8 12 8 14 8-14zM24 18L12 32l20 28zM40 18l12 14-20 28z" fill="none" stroke="#fff" stroke-opacity=".45" stroke-width="1.4" stroke-linejoin="round"/><path d="M24 18l8 14 8-14z" fill="#fff" opacity=".28"/>'; },
    function (c) { /* crystal point */ return '<path d="M22 58V24l10-16 10 16v34z" fill="url(#g)"/><path d="M32 8v50M22 24h20" fill="none" stroke="#fff" stroke-opacity=".45" stroke-width="1.4"/><path d="M32 8l10 16v34l-10 0z" fill="#000" opacity=".12"/><path d="M24 26l6-9v38l-6 3z" fill="#fff" opacity=".3"/>'; },
    function (c) { /* egg-shaped stone */ return '<path d="M32 6C46 6 54 24 54 38c0 12-10 20-22 20S10 50 10 38C10 24 18 6 32 6z" fill="url(#g)"/><ellipse cx="25" cy="22" rx="7" ry="11" fill="#fff" opacity=".3" transform="rotate(18 25 22)"/><ellipse cx="38" cy="48" rx="10" ry="4" fill="#000" opacity=".12"/>'; }
  ];
  function gemSVG(color, i) {
    var hs = hexToHsl(color), c1 = hsl(hs[0], hs[1], hs[2] + 20), c2 = hsl(hs[0], hs[1], hs[2]), c3 = hsl(hs[0], hs[1] + 6, hs[2] - 22);
    var id = 'g' + Math.random().toString(36).slice(2, 8), body = GEM_SHAPES[i % GEM_SHAPES.length](color).replace(/url\(#g\)/g, 'url(#' + id + ')');
    return '<svg viewBox="0 0 64 64" aria-hidden="true"><defs><linearGradient id="' + id + '" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="' + c1 + '"/><stop offset=".55" stop-color="' + c2 + '"/><stop offset="1" stop-color="' + c3 + '"/></linearGradient></defs>' + body + '</svg>';
  }
  function initDig(root, items) {
    var stage = root.querySelector('[data-stage]'), cv = root.querySelector('canvas'), ctx = cv.getContext('2d', { willReadFrequently: true }),
      shelf = root.querySelector('[data-shelf]'), pile = root.querySelector('[data-pile]'), msg = root.querySelector('[data-msg]'), count = root.querySelector('[data-count]'), again = root.querySelector('[data-again]'), gemsEl = root.querySelector('[data-gems]');
    var dpr = Math.min(2, window.devicePixelRatio || 1), W = 0, H = 0, S = 64, gems = [], found = 0, placed = 0, down = false, lx = 0, ly = 0, chk = 0, drag = null;

    function paintDirt() {
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.globalCompositeOperation = 'source-over'; ctx.clearRect(0, 0, W, H);
      var g = ctx.createLinearGradient(0, 0, 0, H); g.addColorStop(0, '#8a6a46'); g.addColorStop(1, '#5e4429'); ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
      for (var i = 0; i < W * H / 90; i++) { var x = Math.random() * W, y = Math.random() * H, r = 0.6 + Math.random() * 2.2; ctx.fillStyle = Math.random() < 0.5 ? 'rgba(255,230,180,' + (0.05 + Math.random() * 0.12) + ')' : 'rgba(30,18,6,' + (0.08 + Math.random() * 0.16) + ')'; ctx.beginPath(); ctx.arc(x, y, r, 0, 6.3); ctx.fill(); }
      for (i = 0; i < 26; i++) { x = Math.random() * W; y = Math.random() * H; var rr = 8 + Math.random() * 16; ctx.fillStyle = 'rgba(40,26,10,.22)'; ctx.beginPath(); ctx.ellipse(x, y, rr, rr * 0.7, Math.random() * 3, 0, 6.3); ctx.fill(); }
    }
    function layout() {
      W = stage.clientWidth; H = stage.clientHeight; cv.width = W * dpr; cv.height = H * dpr; cv.style.width = W + 'px'; cv.style.height = H + 'px';
      var cols = W < 560 ? 4 : 6, rows = Math.ceil(items.length / cols), cw = W / cols, ch = H / rows; S = Math.max(34, Math.min(cw, ch) * 0.7);
      var order = shuffle(items.map(function (_, i) { return i; }));
      gems = items.map(function (it, i) {
        var slot = order[i], c = slot % cols, r = Math.floor(slot / cols), x = c * cw + cw / 2 + (Math.random() - 0.5) * (cw - S) * 0.7, y = r * ch + ch / 2 + (Math.random() - 0.5) * (ch - S) * 0.7;
        return { it: it, i: i, x: x, y: y, found: false, el: gemsEl.children[i] };
      });
      gems.forEach(function (g) { g.el.style.width = S + 'px'; g.el.style.height = S + 'px'; g.el.style.left = (g.x - S / 2) + 'px'; g.el.style.top = (g.y - S / 2) + 'px'; g.el.style.transform = 'rotate(' + ((Math.random() - 0.5) * 40).toFixed(1) + 'deg)'; g.el.classList.remove('is-found', 'is-gone'); });
      paintDirt();
    }
    function status() { count.textContent = T('{n} / {total} placed', { n: placed, total: items.length }); }
    function build() {
      gemsEl.innerHTML = items.map(function (it, i) { return '<span class="dg__gem">' + gemSVG(it.color || '#8fd0ee', i) + '</span>'; }).join('');
      shelf.innerHTML = items.map(function (it, i) { return '<span class="dg__slot" data-slot="' + i + '"><span class="dg__ghost">' + gemSVG(it.color || '#8fd0ee', i) + '</span><b>' + (i + 1) + '</b></span>'; }).join('');
      pile.innerHTML = ''; pile.classList.add('is-empty'); found = 0; placed = 0; status(); msg.textContent = msg.dataset.idle; layout();
    }
    function brush(x, y, x2, y2) {
      ctx.globalCompositeOperation = 'destination-out'; ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.lineWidth = Math.max(36, S * 0.75);
      ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(x2, y2); ctx.stroke();
    }
    function cleared(g) {
      var pts = [[0, 0], [-.28, -.2], [.28, -.2], [-.28, .22], [.28, .22], [0, -.3], [0, .3], [-.35, 0], [.35, 0]], n = 0;
      pts.forEach(function (p) { var px = Math.round((g.x + p[0] * S) * dpr), py = Math.round((g.y + p[1] * S) * dpr); if (px < 0 || py < 0 || px >= cv.width || py >= cv.height) { n++; return; } if (ctx.getImageData(px, py, 1, 1).data[3] < 40) n++; });
      return n / pts.length;
    }
    function sparkleAt(host, x, y) {
      for (var k = 0; k < 10; k++) { var b = document.createElement('i'); b.className = 'dg__spark'; var a = Math.random() * 6.28, d = 24 + Math.random() * 36; b.style.left = x + 'px'; b.style.top = y + 'px'; b.style.setProperty('--dx', Math.cos(a) * d + 'px'); b.style.setProperty('--dy', Math.sin(a) * d + 'px'); host.appendChild(b); setTimeout(function (el) { el.remove(); }.bind(null, b), 800); }
    }
    function toPile(g) {
      var t = document.createElement('span'); t.className = 'dg__tok'; t.setAttribute('data-i', g.i); t.setAttribute('role', 'img'); t.setAttribute('aria-label', g.it.name); t.title = g.it.name; t.innerHTML = gemSVG(g.it.color || '#8fd0ee', g.i);
      pile.appendChild(t); pile.classList.remove('is-empty');
      t.addEventListener('pointerdown', function (e) { lift(e, t, g); });
    }
    function check() {
      gems.forEach(function (g) {
        if (g.found || cleared(g) < 0.78) return;
        g.found = true; found++; g.el.classList.add('is-found'); sparkleAt(stage, g.x, g.y);
        setTimeout(function () { g.el.classList.add('is-gone'); }, 650); toPile(g);
        msg.innerHTML = '<b>' + esc(g.it.name) + '.</b> ' + esc(g.it.line) + (found === 1 ? ' ' + T('Now drag it into its slot below.') : '');
        if (found === items.length) msg.innerHTML += ' ' + T('All found! Put them in their slots.');
      });
    }
    /* ---- pick a stone up, put it in its own slot ---- */
    function lift(e, tok, g) {
      e.preventDefault(); if (drag) return;
      var r = tok.getBoundingClientRect(), fl = document.createElement('span'); fl.className = 'dg__flying'; fl.innerHTML = tok.innerHTML; fl.style.width = r.width * 1.25 + 'px'; fl.style.height = r.height * 1.25 + 'px';
      document.body.appendChild(fl); tok.classList.add('is-lifted'); drag = { tok: tok, g: g, fl: fl, hover: null };
      move(e); document.addEventListener('pointermove', move); document.addEventListener('pointerup', drop); document.addEventListener('pointercancel', drop);
      msg.innerHTML = '<b>' + esc(g.it.name) + '.</b> ' + T('Which slot has its colour?');
    }
    function slotAt(x, y) { var el = document.elementFromPoint(x, y); return el && el.closest ? el.closest('.dg__slot') : null; }
    function move(e) {
      if (!drag) return; var w = parseFloat(drag.fl.style.width); drag.fl.style.left = (e.clientX - w / 2) + 'px'; drag.fl.style.top = (e.clientY - w / 2 - 18) + 'px';
      var sl = slotAt(e.clientX, e.clientY); if (drag.hover && drag.hover !== sl) drag.hover.classList.remove('is-hover'); drag.hover = sl; if (sl && !sl.classList.contains('is-on')) sl.classList.add('is-hover');
    }
    function drop(e) {
      if (!drag) return; document.removeEventListener('pointermove', move); document.removeEventListener('pointerup', drop); document.removeEventListener('pointercancel', drop);
      var d = drag; drag = null; if (d.hover) d.hover.classList.remove('is-hover'); var sl = slotAt(e.clientX, e.clientY); d.fl.remove(); d.tok.classList.remove('is-lifted');
      if (!sl || sl.classList.contains('is-on')) return;
      if (parseInt(sl.getAttribute('data-slot'), 10) === d.g.i) {
        sl.classList.add('is-on', 'is-pop'); sl.innerHTML = '<span class="dg__ghost is-real">' + d.tok.innerHTML + '</span><em>' + esc(d.g.it.name) + '</em>'; d.tok.remove(); placed++; status();
        var r = sl.getBoundingClientRect(), hr = shelf.getBoundingClientRect(); sparkleAt(shelf, r.left - hr.left + r.width / 2, r.top - hr.top + r.height / 2);
        if (!pile.children.length) pile.classList.add('is-empty');
        msg.innerHTML = placed === items.length ? '<b>' + T('Collection complete!') + '</b> ' + T('All {n} stones in their places, just like the box.', { n: items.length }) : '<b>' + T('Yes!') + '</b> ' + T('{name} goes in slot {n}.', { name: esc(d.g.it.name), n: d.g.i + 1 });
      } else {
        sl.classList.add('is-shake'); setTimeout(function () { sl.classList.remove('is-shake'); }, 450); msg.innerHTML = T('Not that one. Look for the slot with {name}.', { name: esc(d.g.it.name.toLowerCase()) });
      }
    }
    function pos(e) { var r = stage.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; }
    stage.addEventListener('pointerdown', function (e) { e.preventDefault(); down = true; var p = pos(e); lx = p[0]; ly = p[1]; stage.classList.add('is-digging'); try { stage.setPointerCapture(e.pointerId); } catch (er) {} brush(lx, ly, lx + 0.1, ly + 0.1); });
    stage.addEventListener('pointermove', function (e) { if (!down) return; var p = pos(e); brush(lx, ly, p[0], p[1]); lx = p[0]; ly = p[1]; var t = performance.now(); if (t - chk > 110) { chk = t; check(); } });
    function end() { if (!down) return; down = false; stage.classList.remove('is-digging'); check(); }
    stage.addEventListener('pointerup', end); stage.addEventListener('pointercancel', end);
    again.addEventListener('click', build);
    var rt; function relayout() { clearTimeout(rt); rt = setTimeout(function () { if (!found) layout(); }, 120); }
    window.addEventListener('resize', relayout); root.addEventListener('advp:resize', relayout);
    build();
  }

  /* ---------------- Snake game ---------------- */
  function initSnake(root) {
    var stage = root.querySelector('[data-stage]'), cv = root.querySelector('canvas'), ctx = cv.getContext('2d'), over = root.querySelector('[data-over]'),
      scoreEl = root.querySelector('[data-score]'), bestEl = root.querySelector('[data-best]'), msg = root.querySelector('[data-msg]'), restart = root.querySelector('[data-restart]'), pad = root.querySelector('[data-pad]');
    var dpr = Math.min(2, window.devicePixelRatio || 1), cols = 40, rows = 20, cell = 20, snake = [], prev = [], dir = [1, 0], queue = [], food = null, bombs = [], posts = [], blast = null, reached = false, eaten = 0, grow = 0, score = 0, best = 0, state = 'idle', acc = 0, last = 0, raf = 0, fx = [], tickMs = 130,
      goal = parseInt(root.getAttribute('data-goal'), 10) || 300, prefix = root.getAttribute('data-code') || '', code = '', rewardEl = root.querySelector('[data-reward]'), goalEl = root.querySelector('[data-goal-txt]'), earned = false,
      palette = ['#c0562f', '#7a8a8f', '#6a4a2c', '#5ec3f0', '#3f9d3f', '#f08a1c'];
    try { best = parseInt(localStorage.getItem('mk-snake-best'), 10) || 0; earned = localStorage.getItem('mk-snake-reward') === today().key; } catch (e) {}
    function today() { var d = new Date(), y = d.getUTCFullYear(), m = d.getUTCMonth(), dd = d.getUTCDate(); return { key: ('0' + (m + 1)).slice(-2) + ('0' + dd).slice(-2), end: new Date(Date.UTC(y, m, dd + 1)) }; }
    function showReward() {
      if (!rewardEl || !prefix) return; var td = today(); code = prefix + td.key; rewardEl.hidden = false; rewardEl.querySelector('[data-code]').textContent = code;
      var u = rewardEl.querySelector('[data-until]'); if (u) { var hh = td.end.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }); u.textContent = T('Valid today only, until {time}', { time: hh }); }
      var a = rewardEl.querySelector('[data-use]'); if (a) a.setAttribute('href', rootPath(root) + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(rootPath(root) + '/collections/all'));
    }
    function goalText() { if (goalEl) goalEl.textContent = Math.min(score, goal) + ' / ' + goal; }
    function fit() {
      var w = stage.clientWidth - 28, h = stage.clientHeight - 28; if (w < 60 || h < 60) return;   /* keep a visible margin so the edge rows are never clipped */
      var target = w < 560 ? 15 : 19; cols = Math.max(24, Math.floor(w / target)); rows = Math.max(16, Math.floor(h / target));
      cell = Math.floor(Math.min(w / cols, h / rows)); var cw = cell * cols, ch = cell * rows;
      cv.width = cw * dpr; cv.height = ch * dpr; cv.style.width = cw + 'px'; cv.style.height = ch + 'px'; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      if (state === 'idle') reset(); draw(1);
    }
    function reset() {
      var cx = Math.floor(cols / 3), cy = Math.floor(rows / 2); snake = []; for (var i = 0; i < 5; i++) snake.push([cx - i, cy]); prev = snake.map(function (q) { return q.slice(); });
      dir = [1, 0]; queue = []; score = 0; eaten = 0; grow = 0; bombs = []; posts = []; blast = null; reached = false; fx = []; tickMs = 130; scoreEl.textContent = '0'; bestEl.textContent = best; goalText(); if (rewardEl && !earned) rewardEl.hidden = true; placeFood();
    }
    function freeCell(x, y) {
      return !snake.some(function (q) { return q[0] === x && q[1] === y; }) && !(food && food.x === x && food.y === y) && !bombs.some(function (b) { return x >= b.x && x <= b.x + 1 && y >= b.y && y <= b.y + 1; }) && !posts.some(function (q) { return x === q.x && y >= q.y && y <= q.y + 2; });
    }
    function placeFood() {
      for (var t = 0; t < 200; t++) { var x = Math.floor(Math.random() * cols), y = Math.floor(Math.random() * rows); if (freeCell(x, y)) { food = { x: x, y: y, c: palette[Math.floor(Math.random() * palette.length)] }; return; } }
    }
    function start() { reset(); state = 'run'; over.hidden = true; msg.textContent = msg.dataset.run; acc = 0; last = performance.now(); raf = requestAnimationFrame(loop); }
    function stop(why) {
      state = 'over'; cancelAnimationFrame(raf); var wy = over.querySelector('[data-why]'); if (wy) wy.textContent = why === 'bomb' ? T('Boom! You touched the dynamite.') : why === 'post' ? T('You hit a post.') : why === 'tail' ? T('You bit your own tail.') : '';
      if (score > best) { best = score; try { localStorage.setItem('mk-snake-best', best); } catch (e) {} } bestEl.textContent = best; over.querySelector('[data-final]').textContent = score; over.hidden = false; if (earned) showReward(); draw(1);
    }
    function turn(dx, dy) {
      if (state === 'blast') return; if (state === 'over') { again(); return; } if (state === 'idle') start();
      if (state === 'pause') { state = 'run'; msg.textContent = msg.dataset.run; acc = 0; last = performance.now(); raf = requestAnimationFrame(loop); }
      var ref = queue.length ? queue[queue.length - 1] : dir;
      if ((dx === -ref[0] && dy === -ref[1]) || (dx === ref[0] && dy === ref[1])) return;
      if (queue.length < 2) queue.push([dx, dy]);
    }
    function spawnBomb() {
      for (var t = 0; t < 60; t++) {
        var x = Math.floor(Math.random() * (cols - 1)), y = Math.floor(Math.random() * (rows - 1)), hx = snake[0][0], hy = snake[0][1], dx = Math.min(Math.abs(x - hx), cols - Math.abs(x - hx)), dy = Math.min(Math.abs(y - hy), rows - Math.abs(y - hy));
        if (freeCell(x, y) && freeCell(x + 1, y) && freeCell(x, y + 1) && freeCell(x + 1, y + 1) && dx + dy > 9) { bombs.push({ x: x, y: y, life: 70 }); return; }
      }
    }
    function spawnPost() {
      for (var t = 0; t < 80; t++) {
        var x = Math.floor(Math.random() * cols), y = Math.floor(Math.random() * (rows - 2)), hx = snake[0][0], hy = snake[0][1], dx = Math.min(Math.abs(x - hx), cols - Math.abs(x - hx)), dy = Math.min(Math.abs(y - hy), rows - Math.abs(y - hy));
        if (freeCell(x, y) && freeCell(x, y + 1) && freeCell(x, y + 2) && dx + dy > 9) { posts.push({ x: x, y: y }); return; }
      }
    }
    function startBlast(cx, cy) { boom(cx, cy); state = 'blast'; blast = { t0: performance.now(), x: cx * cell, y: cy * cell }; raf = requestAnimationFrame(blastLoop); setTimeout(function () { if (blast) { blast = null; cancelAnimationFrame(raf); stop('bomb'); } }, 900); }
    function blastLoop(t) {
      var k = (t - blast.t0) / 800; if (k >= 1) { blast = null; return stop('bomb'); }
      draw(1); raf = requestAnimationFrame(blastLoop);
    }
    function boom(cx, cy) { for (var k = 0; k < 34; k++) fx.push({ x: cx * cell, y: cy * cell, vx: (Math.random() - .5) * 11, vy: (Math.random() - .5) * 11, l: 1.4, c: k % 2 ? '#ff7a1a' : '#ffd34d' }); }
    function afterScore() {
        tickMs = Math.max(85, 130 - Math.floor(score / 60) * 3); goalText();
        if (score >= 100) { var want = Math.min(5, 1 + Math.floor((score - 100) / 60)), had = posts.length; while (posts.length < want) { var before = posts.length; spawnPost(); if (posts.length === before) break; } if (posts.length > had) msg.textContent = T('A post appeared! Steer around it.'); }
        if (!reached && score >= goal) { reached = true; if (!earned) { earned = true; try { localStorage.setItem('mk-snake-reward', today().key); } catch (e) {} } showReward(); msg.textContent = T('Goal reached! Your discount code is on screen.'); }
    }
    function step() {
      if (queue.length) dir = queue.shift();
      prev = snake.map(function (q) { return q.slice(); });
      var h = [(snake[0][0] + dir[0] + cols) % cols, (snake[0][1] + dir[1] + rows) % rows];   /* through the walls, like the old phone game */
      for (var i = bombs.length - 1; i >= 0; i--) {
        var b = bombs[i];
        if (h[0] >= b.x && h[0] <= b.x + 1 && h[1] >= b.y && h[1] <= b.y + 1) { snake.unshift(h); bombs.splice(i, 1); return startBlast(b.x + 1, b.y + 1); }
        if (--b.life <= 0) bombs.splice(i, 1);
      }
      if (posts.some(function (q) { return h[0] === q.x && h[1] >= q.y && h[1] <= q.y + 2; })) { snake.unshift(h); return stop('post'); }
      if (snake.some(function (q, j) { return j < snake.length - 1 && q[0] === h[0] && q[1] === h[1]; })) return stop('tail');
      snake.unshift(h);
      if (h[0] === food.x && h[1] === food.y) {
        score += 10; eaten++; grow += 3; scoreEl.textContent = score; afterScore();
        for (var k = 0; k < 12; k++) fx.push({ x: (h[0] + .5) * cell, y: (h[1] + .5) * cell, vx: (Math.random() - .5) * 5, vy: (Math.random() - .5) * 5, l: 1, c: food.c });
        placeFood(); if (eaten >= 2 && eaten % 2 === 0 && bombs.length < 3) spawnBomb();
      }
      if (grow > 0) grow--; else snake.pop();
    }
    function block(x, y, c) {
      var p = cell * 0.06, s = cell - 2 * p; ctx.fillStyle = c; ctx.fillRect(x * cell + p, y * cell + p, s, s);
      ctx.fillStyle = 'rgba(255,255,255,.28)'; ctx.fillRect(x * cell + p, y * cell + p, s, s * .34);
      ctx.fillStyle = 'rgba(0,0,0,.2)'; ctx.fillRect(x * cell + p + s * .55, y * cell + p + s * .5, s * .22, s * .22); ctx.fillRect(x * cell + p + s * .15, y * cell + p + s * .62, s * .2, s * .2);
      ctx.strokeStyle = 'rgba(0,0,0,.4)'; ctx.lineWidth = 1; ctx.strokeRect(x * cell + p + .5, y * cell + p + .5, s - 1, s - 1);
      var g = 0.5 + 0.5 * Math.sin(performance.now() / 180); ctx.strokeStyle = 'rgba(255,243,176,' + (0.25 + g * 0.35) + ')'; ctx.lineWidth = 2; ctx.strokeRect(x * cell - 1, y * cell - 1, cell + 2, cell + 2);
    }
    function post(x, y) {
      var X = x * cell, Y = y * cell, w = cell, h = cell * 3;
      ctx.fillStyle = 'rgba(0,0,0,.3)'; ctx.fillRect(X + cell * .22, Y + h - cell * .1, cell * .7, cell * .16);
      ctx.fillStyle = '#8a5a35'; ctx.fillRect(X + cell * .26, Y + cell * .1, w * .48, h - cell * .15);
      ctx.fillStyle = 'rgba(255,255,255,.2)'; ctx.fillRect(X + cell * .26, Y + cell * .1, w * .14, h - cell * .15);
      ctx.fillStyle = 'rgba(0,0,0,.25)'; for (var i = 1; i < 6; i++) ctx.fillRect(X + cell * .26, Y + cell * .1 + i * (h - cell * .15) / 6, w * .48, 2);
      ctx.fillStyle = '#e8d8b0'; ctx.fillRect(X + cell * .2, Y, w * .6, cell * .22);
      ctx.fillStyle = '#d23a2a'; ctx.fillRect(X + cell * .26, Y + cell * .22, w * .48, cell * .3); ctx.fillStyle = '#fff'; ctx.fillRect(X + cell * .26, Y + cell * .52, w * .48, cell * .3);
    }
    function dynamite(x, y, life) {
      if (life <= 14 && Math.floor(life / 3) % 2) return;   /* blinks before it goes away */
      var C = cell * 2, X = x * cell, Y = y * cell, w = C * .26, gp = C * .04;
      [0, 1, 2].forEach(function (i) { var bx = X + C * .14 + i * (w + gp); ctx.fillStyle = i === 1 ? '#e03a2a' : '#c42a1e'; ctx.fillRect(bx, Y + C * .3, w, C * .56); ctx.fillStyle = 'rgba(255,255,255,.28)'; ctx.fillRect(bx + w * .15, Y + C * .3, w * .22, C * .56); });
      ctx.fillStyle = '#f2e6c8'; ctx.fillRect(X + C * .1, Y + C * .5, C * .8, C * .17); ctx.fillStyle = '#222'; ctx.font = 'bold ' + Math.max(7, Math.round(C * .14)) + 'px sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText('TNT', X + C * .5, Y + C * .585);
      ctx.strokeStyle = '#3a2a1a'; ctx.lineWidth = Math.max(2, C * .05); ctx.beginPath(); ctx.moveTo(X + C * .5, Y + C * .3); ctx.quadraticCurveTo(X + C * .56, Y + C * .1, X + C * .72, Y + C * .1); ctx.stroke();
      ctx.fillStyle = '#ffd34d'; ctx.beginPath(); ctx.arc(X + C * .72, Y + C * .1, C * (.05 + .03 * Math.sin(performance.now() / 70)), 0, 6.3); ctx.fill();
    }
    function pos(i, t) {   /* where segment i is drawn: it glides from its old cell to the new one, also across a wall (the shortest way round) */
      var to = snake[i], from = prev[i] || to, dx = to[0] - from[0], dy = to[1] - from[1];
      if (dx > cols / 2) dx -= cols; else if (dx < -cols / 2) dx += cols;
      if (dy > rows / 2) dy -= rows; else if (dy < -rows / 2) dy += rows;
      var x = from[0] + .5 + dx * t, y = from[1] + .5 + dy * t;
      return [((x % cols) + cols) % cols, ((y % rows) + rows) % rows];
    }
    function wrapDelta(a, b) {   /* shortest vector from a to b on the wrapped board */
      var dx = b[0] - a[0], dy = b[1] - a[1];
      if (dx > cols / 2) dx -= cols; else if (dx < -cols / 2) dx += cols;
      if (dy > rows / 2) dy -= rows; else if (dy < -rows / 2) dy += rows;
      return [dx, dy];
    }
    function draw(t) {
      var cw = cols * cell, ch = rows * cell, i; ctx.clearRect(0, 0, cw, ch);
      for (var x = 0; x < cols; x++) for (var y = 0; y < rows; y++) { ctx.fillStyle = (x + y) % 2 ? '#233326' : '#213024'; ctx.fillRect(x * cell, y * cell, cell, cell); }
      if (food) block(food.x, food.y, food.c);
      posts.forEach(function (q) { post(q.x, q.y); });
      bombs.forEach(function (bm) { dynamite(bm.x, bm.y, bm.life); });
      var shake = 0; if (blast) { var bk = (performance.now() - blast.t0) / 800; shake = (1 - bk) * cell * .6; ctx.save(); ctx.translate((Math.random() - .5) * shake, (Math.random() - .5) * shake); }
      var n = snake.length, R = cell * 0.46, P = [];
      for (i = 0; i < n; i++) P.push(pos(i, t));
      [-1, 0, 1].forEach(function (oy) { [-1, 0, 1].forEach(function (ox) {   /* draw the snake again one board to each side, so the part that is past a wall shows up on the other side */
        var OX = ox * cols * cell, OY = oy * rows * cell, j;
        if (ox && (P[0][0] * cell + OX < -cell * 2 || P[0][0] * cell + OX > cw + cell * 2) && !P.some(function (q) { var X = q[0] * cell + OX; return X > -cell && X < cw + cell; })) return;
        if (oy && !P.some(function (q) { var Y = q[1] * cell + OY; return Y > -cell && Y < ch + cell; })) return;
        for (j = n - 1; j >= 0; j--) {
          var k = 1 - j / Math.max(n, 12) * 0.5, r = j === 0 ? R * 1.08 : R * (0.8 + 0.2 * k), cx = P[j][0] * cell + OX, cy = P[j][1] * cell + OY;
          ctx.fillStyle = 'hsl(' + (152 - j * 1.4) + ',58%,' + (46 * k + 10) + '%)'; ctx.strokeStyle = ctx.fillStyle;
          if (j < n - 1) { var d = wrapDelta(P[j], P[j + 1]); ctx.lineWidth = r * 2; ctx.lineCap = 'round'; ctx.beginPath(); ctx.moveTo(cx, cy); ctx.lineTo(cx + d[0] * cell, cy + d[1] * cell); ctx.stroke(); }
          ctx.beginPath(); ctx.arc(cx, cy, r, 0, 6.3); ctx.fill();
        }
        var ex = P[0][0] * cell + OX, ey = P[0][1] * cell + OY, px = -dir[1], py = dir[0];
        [-1, 1].forEach(function (sd) { var X = ex + dir[0] * cell * .16 + px * sd * cell * .24, Y = ey + dir[1] * cell * .16 + py * sd * cell * .24; ctx.fillStyle = '#fff'; ctx.beginPath(); ctx.arc(X, Y, cell * .17, 0, 6.3); ctx.fill(); ctx.fillStyle = '#111'; ctx.beginPath(); ctx.arc(X + dir[0] * cell * .05, Y + dir[1] * cell * .05, cell * .08, 0, 6.3); ctx.fill(); });
      }); });
      if (blast) {
        var bk2 = (performance.now() - blast.t0) / 800; ctx.restore();
        ctx.strokeStyle = 'rgba(255,220,120,' + (1 - bk2) + ')'; ctx.lineWidth = cell * .5 * (1 - bk2) + 2; ctx.beginPath(); ctx.arc(blast.x, blast.y, bk2 * cell * 9, 0, 6.3); ctx.stroke();
        ctx.fillStyle = 'rgba(255,230,160,' + Math.max(0, .75 - bk2 * 2.4) + ')'; ctx.fillRect(0, 0, cw, ch);
      }
      for (i = fx.length - 1; i >= 0; i--) { var f = fx[i]; f.x += f.vx; f.y += f.vy; f.vy += .08; f.l -= 0.025; if (f.l <= 0) { fx.splice(i, 1); continue; } ctx.globalAlpha = Math.min(1, f.l); ctx.fillStyle = f.c; ctx.fillRect(f.x - 2.5, f.y - 2.5, 5, 5); ctx.globalAlpha = 1; }
    }
    function loop(t) {
      if (state !== 'run') return; acc += Math.min(t - last, 250); last = t;
      while (acc >= tickMs && state === 'run') { acc -= tickMs; step(); }
      if (state === 'run') { draw(Math.min(1, acc / tickMs)); raf = requestAnimationFrame(loop); }
    }
    var KEYS = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1], KeyA: [-1, 0], KeyD: [1, 0], KeyW: [0, -1], KeyS: [0, 1] };
    document.addEventListener('keydown', function (e) {
      var r = stage.getBoundingClientRect(); if (!r.width || r.bottom < 0 || r.top > innerHeight) return;
      var k = KEYS[e.code] || KEYS[e.key];
      if (state === 'over' && (k || e.code === 'Space' || e.code === 'Enter')) { e.preventDefault(); again(); return; }
      if (!k) { if ((e.code === 'Space' || e.code === 'Enter') && state === 'idle') { e.preventDefault(); start(); } return; }
      e.preventDefault(); turn(k[0], k[1]);
    });
    var sx = 0, sy = 0, sw = false;
    function onControl(e) { return e.target.closest && e.target.closest('button, a, .sk__reward'); }
    root.addEventListener('pointerdown', function (e) {   /* swipe anywhere on the game (not on a button) */
      if (onControl(e) || !root.classList.contains('is-full')) return;
      sx = e.clientX; sy = e.clientY; sw = true; if (state === 'idle') start();
      if (e.pointerType === 'mouse' && state === 'run' && snake.length && stage.contains(e.target)) {   /* mouse: click where you want the snake to go */
        var r = cv.getBoundingClientRect(), hx = r.left + (snake[0][0] + .5) * cell, hy = r.top + (snake[0][1] + .5) * cell, dx = e.clientX - hx, dy = e.clientY - hy;
        if (Math.abs(dx) > Math.abs(dy)) turn(dx > 0 ? 1 : -1, 0); else turn(0, dy > 0 ? 1 : -1);
      }
    });
    root.addEventListener('pointermove', function (e) {
      if (!sw || e.pointerType === 'mouse') return; var dx = e.clientX - sx, dy = e.clientY - sy; if (Math.hypot(dx, dy) < 14) return;
      if (Math.abs(dx) > Math.abs(dy)) turn(dx > 0 ? 1 : -1, 0); else turn(0, dy > 0 ? 1 : -1); sx = e.clientX; sy = e.clientY;
    });
    var endSw = function () { sw = false; }; root.addEventListener('pointerup', endSw); root.addEventListener('pointercancel', endSw);
    function padHit(e) { var b = e.target.closest ? e.target.closest('[data-d]') : null; if (!b) return; var d = b.getAttribute('data-d').split(',').map(Number); turn(d[0], d[1]); b.classList.add('is-hit'); setTimeout(function () { b.classList.remove('is-hit'); }, 140); }
    pad.addEventListener('pointerdown', function (e) { e.preventDefault(); padHit(e); });
    pad.addEventListener('click', function (e) { if (e.detail === 0) padHit(e); });   /* keyboard activation of a focused button */
    var cpy = root.querySelector('[data-copy]'); if (cpy) cpy.addEventListener('click', function () { try { navigator.clipboard.writeText(code); cpy.textContent = T('Copied!'); } catch (e) { cpy.textContent = code; } setTimeout(function () { cpy.textContent = T('Copy'); }, 1800); });
    function again() { cancelAnimationFrame(raf); state = 'idle'; over.hidden = true; reset(); draw(1); start(); }
    restart.addEventListener('click', again); over.querySelector('[data-replay]').addEventListener('click', again);
    document.addEventListener('visibilitychange', function () { if (document.hidden && state === 'run') { state = 'pause'; cancelAnimationFrame(raf); msg.textContent = T('Paused. Press an arrow to go on.'); } });
    var rt, lw = 0, lh = 0; function refit() { clearTimeout(rt); rt = setTimeout(function () { var w = stage.clientWidth, h = stage.clientHeight; if (Math.abs(w - lw) < 3 && Math.abs(h - lh) < 3) return; lw = w; lh = h; if (state === 'run') { state = 'idle'; cancelAnimationFrame(raf); } fit(); }, 120); }
    window.addEventListener('resize', refit); root.addEventListener('advp:resize', refit);
    root.__sk = { spawnBomb: spawnBomb, draw: draw, head: function () { return snake[0]; }, cols: function () { return cols; }, blast: function (x, y) { startBlast(x, y); }, dir: function () { return dir; }, state: function () { return state; }, cheat: function (n) { score = n; scoreEl.textContent = n; afterScore(); }, freeze: function () { state = 'pause'; cancelAnimationFrame(raf); }, set: function (sn, pv, d) { snake = sn; prev = pv; dir = d; } };   /* handy for testing */
    lw = stage.clientWidth; lh = stage.clientHeight; fit();
  }

  /* ---------------- Play card + full-screen player. The game itself is built only when the child presses Play, so pages stay light. ---------------- */
  var ICONS = {
    gem: '<path d="M32 8l20 12 10 14-30 28L2 34 12 20z"/><path d="M12 20h40M2 34h60M32 8l-8 12 8 14 8-14z"/>',
    crash: '<path d="M32 4l6 14 15-5-7 14 14 6-15 5 6 14-14-7-5 15-5-15-14 7 6-14-15-5 14-6-7-14 15 5z"/>',
    duck: '<path d="M14 40c0-10 7-18 17-18 4 0 7 1 10 3l10-3-2 8c3 3 5 7 5 12 0 10-8 16-20 16S14 50 14 40z"/><circle cx="36" cy="26" r="2.4" fill="currentColor" stroke="none"/><path d="M42 31l11 2-9 4"/>',
    snake: '<path d="M10 50c0-12 20-8 20-20S10 22 14 12c4-6 14-4 18 2"/><path d="M52 18c4 4 4 12-2 16-8 6-16 2-14 14 1 6 8 8 14 6"/><circle cx="14" cy="13" r="2.2" fill="currentColor" stroke="none"/>',
    race: '<path d="M14 8v50"/><path d="M14 10h38l-8 10 8 10H14"/><path d="M22 10v20M30 10v20M38 10v20M46 10v20" opacity=".4"/>'
  };
  function icon(n) { return ICONS[n] ? '<svg viewBox="0 0 64 64" width="38" height="38" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round">' + ICONS[n] + '</svg>' : esc(n || '🎮'); }
  var OPEN = null;
  function shell(root, init) {
    var bar = root.querySelector('.advp__bar'), spacer = null, ready = false;
    var cb = document.createElement('button'); cb.type = 'button'; cb.className = 'advp__close'; cb.setAttribute('aria-label', T('Close game')); cb.innerHTML = '<span>&times;</span> ' + T('Close');
    root.appendChild(cb);
    var title = root.getAttribute('data-cover-title') || T('Play free');
    var cover = document.createElement('div'); cover.className = 'advp__cover';
    cover.innerHTML = '<span class="advp__cover-art" aria-hidden="true">' + icon(root.getAttribute('data-cover-icon')) + '</span><span class="advp__cover-txt"><span class="advp__free">' + T('Free game') + '</span><strong>' + esc(title) + '</strong><span>' + esc(root.getAttribute('data-cover-text') || '') + '</span></span><button type="button" class="advp__play">' + T('Play') + '</button>';
    root.insertBefore(cover, root.firstChild); root.classList.add('has-cover');
    function emit() { root.dispatchEvent(new CustomEvent('advp:resize')); window.dispatchEvent(new Event('resize')); }
    function open() {
      if (root.classList.contains('is-full')) return; if (OPEN) OPEN();
      spacer = document.createElement('div'); spacer.className = 'advp__spacer'; spacer.style.height = root.offsetHeight + 'px'; root.parentNode.insertBefore(spacer, root);
      document.body.appendChild(root);   /* out of the page's stacking contexts, so it sits above the dimmed page */
      root.classList.add('is-full'); document.documentElement.classList.add('advp-lock'); OPEN = close;
      if (!ready) { ready = true; init(); } else { setTimeout(emit, 60); }
      setTimeout(emit, 350);
    }
    function close() {
      if (!root.classList.contains('is-full')) return;
      root.classList.remove('is-full'); document.documentElement.classList.remove('advp-lock'); if (spacer) { spacer.parentNode.insertBefore(root, spacer); spacer.remove(); spacer = null; } if (OPEN === close) OPEN = null;
    }
    cover.addEventListener('click', open); cb.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    root.__advOpen = open;
  }

  /* ---------------- Duck waves ---------------- */
  function initWave(root, items) {
    var pool = root.querySelector('[data-pool]'), info = root.querySelector('[data-msg]'), btn = root.querySelector('[data-waves]'), cols = 6, rows = Math.ceil(items.length / cols);
    items.forEach(function (it, i) {
      var r = Math.floor(i / cols), c = i % cols, d = document.createElement('button');
      d.type = 'button'; d.className = 'wv__duck'; d.setAttribute('aria-label', it.name);
      d.style.left = (10 + c * 15.5 + (r % 2 ? 3 : 0) + (Math.random() - 0.5) * 2) + '%'; d.style.top = (22 + r * 17 + (Math.random() - 0.5) * 2) + '%';
      d.style.setProperty('--dur', (2.4 + Math.random() * 2).toFixed(2) + 's'); d.style.setProperty('--dl', (-Math.random() * 3).toFixed(2) + 's'); d.style.setProperty('--dx', (4 + Math.random() * 10).toFixed(1) + 'px');
      d.innerHTML = '<span class="wv__img">' + img(it) + '</span><span class="wv__tip">' + esc(it.name) + '</span>';
      d.addEventListener('pointerdown', function () {
        d.classList.remove('is-splash'); void d.offsetWidth; d.classList.add('is-splash');
        var ring = document.createElement('span'); ring.className = 'wv__ring'; ring.style.left = d.style.left; ring.style.top = d.style.top; pool.appendChild(ring);
        setTimeout(function () { ring.remove(); }, 950); clearTimeout(d._t); d._t = setTimeout(function () { d.classList.remove('is-splash'); }, 1000);
        info.innerHTML = '<b>' + esc(it.name) + '.</b> ' + esc(it.line);
      });
      pool.appendChild(d);
    });
    var st;
    btn.addEventListener('click', function () {
      pool.classList.add('is-stormy'); info.textContent = T('Big waves! Hold on, ducks!');
      clearTimeout(st); st = setTimeout(function () { pool.classList.remove('is-stormy'); info.textContent = info.dataset.idle; }, 4500);
    });
  }

  var inits = { race: initRace, sandbox: initSandbox, tree: initTree, wave: initWave, dig: initDig, snake: initSnake };
  function boot() {
    document.querySelectorAll('[data-adv]').forEach(function (el) {
      var f = inits[el.getAttribute('data-adv')], d = el.querySelector('[data-adv-data]');
      if (!f || (!d && el.getAttribute('data-adv') !== 'snake') || el.__advReady) return;
      el.__advReady = true;
      try { var data = d ? JSON.parse(d.textContent) : null; shell(el, function () { try { f(el, data); } catch (e) { if (window.console) console.error('adv-play', e); } }); } catch (e) { if (window.console) console.error('adv-play', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
